import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  viewChild,
} from '@angular/core';

import type { FullCandidate } from '@core/candidate-types';
import { EvaluateCandidateButtonComponent } from '@core/candidate-ui';
import {
  AddQuickEvaluationDropdownComponent,
  EditQuickEvaluationDropdownComponent,
} from '@core/interview-results-legacy';
import type { Placement } from '@core/placements-types';
import { WalkthroughStepOriginDirective } from '@core/walkthrough-ui';

@Component({
  selector: 'rt-quick-candidate-evaluation',
  template: `
    <rt-evaluate-candidate-button
      #evaluateCandidateButtonComponent
      [rating]="candidate().myLastRating"
      [newEvaluationDropdownTpl]="newEvaluationDropdownTpl"
      [editEvaluationDropdownTpl]="editEvaluationDropdownTpl"
      [rtWalkthroughOriginStepId]="'walkthrough-step-evaluate-candidate-2'"
    />
    <ng-template #newEvaluationDropdownTpl>
      <rt-add-quick-evaluation-dropdown
        [candidate]="candidate()"
        [hasAccessToAllJobOffers]="hasAccessToAllJobOffers()"
        [availablePlacements]="availablePlacements()"
        [dropdownRef]="evaluateCandidateButtonComponent.overlay()!"
        [isActionToolbar]="false"
        [quickEvaluationTrigger]="'profileThumbs'"
        [asDropdownTemplate]="!!candidate().myLastRating"
        [hasBackAction]="!!candidate().myLastRating"
        (optionsClick)="openInEvaluationTab.emit()"
        (goBack)="nestedDropdownParent()?.prevTemplate()"
      />
    </ng-template>
    <ng-template #editEvaluationDropdownTpl>
      <rt-edit-quick-evaluation-dropdown
        [candidate]="candidate()"
        [addAnotherEvaluationTpl]="newEvaluationDropdownTpl"
        (openInEvaluationTab)="openInEvaluationTab.emit()"
      />
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AddQuickEvaluationDropdownComponent,
    EditQuickEvaluationDropdownComponent,
    EvaluateCandidateButtonComponent,
    WalkthroughStepOriginDirective,
  ],
})
export class QuickCandidateEvaluationComponent {
  public candidate = input.required<FullCandidate>();

  public hasAccessToAllJobOffers = input.required<boolean>();

  public availablePlacements = input.required<Placement[]>();

  public openInEvaluationTab = output<void>();

  public nestedDropdownParent = computed(() =>
    this.editQuickEvaluationDropdownComponent()?.rtDropdown(),
  );

  private editQuickEvaluationDropdownComponent = viewChild(EditQuickEvaluationDropdownComponent);
}
